import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { fbTrack } from "@/lib/metaPixel";
import { useI18n } from "@/i18n/I18nContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [polling, setPolling] = useState(true);
  const { t } = useI18n();

  useEffect(() => {
    if (!sessionId) { setPolling(false); return; }
    let tries = 0; let cancelled = false;
    let purchaseFired = false;
    async function poll() {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status === "paid") {
          // Meta Pixel — Purchase conversion. Fire once with real money value.
          if (!purchaseFired) {
            purchaseFired = true;
            fbTrack("Purchase", {
              value: Number(data.total || data.subtotal || 0),
              currency: (data.currency || "EUR").toUpperCase(),
              content_ids: [data.booking_id],
              content_type: "product",
            });
          }
          setPolling(false); return;
        }
        if (tries > 15) { setPolling(false); return; }
      } catch { /* keep trying */ }
      tries++;
      setTimeout(poll, 2000);
    }
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const paid = status?.payment_status === "paid";
  return (
    <>
      <Nav />
      <div className="pt-40 pb-32 max-w-[900px] mx-auto px-6 text-center">
        <div className="overline">{paid ? t("success.tag_ok") : t("success.tag_pending")}</div>
        <h1 data-testid="success-heading" className="font-serif text-6xl md:text-7xl font-light mt-6">
          {paid ? t("success.heading_ok") : polling ? t("success.heading_pending") : t("success.heading_await")}
        </h1>
        {status && (
          <div className="mt-12 border border-soft_border bg-white p-10 text-left inline-block min-w-[420px]">
            <div className="grid grid-cols-2 gap-6 text-sm">
              <div><div className="overline">{t("success.guest")}</div><div className="font-serif text-xl mt-1">{status.guest_name || "—"}</div></div>
              <div><div className="overline">{t("success.booking")}</div><div className="font-serif text-xl mt-1">#{status.booking_id?.slice(0,8)}</div></div>
              <div><div className="overline">{t("booking.checkin")}</div><div className="font-serif text-xl mt-1">{status.checkin}</div></div>
              <div><div className="overline">{t("booking.checkout")}</div><div className="font-serif text-xl mt-1">{status.checkout}</div></div>
              <div className="col-span-2 hairline pt-4 flex justify-between font-serif text-2xl">
                <span>{t("success.total_paid")}</span><span data-testid="success-total">€{status.amount?.toFixed(2)}</span>
              </div>
            </div>
          </div>
        )}
        <p className="mt-12 text-ionian/70">{t("success.body")}</p>
        <Link to="/" className="btn-ionian inline-block mt-10 px-10 py-4 rounded-full text-sm uppercase tracking-widest">{t("success.back")}</Link>
      </div>
      <Footer />
    </>
  );
}
